module.exports = __webpack_public_path__ + "static/media/logoBlur.7ab0f451.png";